import {
	WMSLayer,
    WMSLayerToLegendItemAdapter,
    GeoReferencedImageSource,
	Util,
    MapUtil
} from "cartovista";



    WMSLayer.prototype.getFields = function (e, t) {
        if(typeof this.fields === "undefined"){
        var s = this._source.src + "?&SERVICE=WMS&request=DescribeLayer&version=" + 
            this._source.wmsSourceGetFeatureInfo.version + "&layers=" + this._source.wmsSourceGetFeatureInfo.layers.join() + "&sld_version=1.1.0";
        this.fields = {};
        Util.loadXML(s, function (r, o) {
                var s = r.getElementsByTagName("se:FeatureTypeName");
                if (s.length > 0) {
                    for (var d = s.length, h = 0; h < d; h++) {
                        var layerName = s[h].textContent;
                        this.fields[layerName] = [];
                        var wfs = this._source.src + "?&SERVICE=wfs&request=describefeaturetype&version=1.1.0" + "&&typename=" + layerName;
                            Util.loadXML(wfs, function (layerName, r, o) {
                                    var s = r.getElementsByTagName("element");
                                    if (s.length > 0) {
                                        for (var d = s.length, h = 0; h < d; h++) {
                                            var fieldName = s[h].getAttribute("name");
                                            if(fieldName !== "geometry" && fieldName !== layerName){
                                                this.fields[layerName].push(fieldName);
                                            }
                                        }
                                    }
                            }.bind(this, layerName), function (r, o) {
                                this.fields = null;
                                throw i.call(n || this, {
                                    layer: this,
                                    point: [ e, t ],
                                    searchRadius: 1,
                                    features: [],
                                    maxCount: Number.POSITIVE_INFINITY
                                }),
                                new Error("CartoVista loading failed for resource " + o + " from url " + window.location)
                            }.bind(this), false, null, false)
                    }
                }
        }.bind(this), function (r, o) {
            this.fields = null;
            throw i.call(n || this, {
                layer: this,
                point: [ e, t ],
                searchRadius: 1,
                features: [],
                maxCount: Number.POSITIVE_INFINITY
            }),
            new Error("CartoVista loading failed for resource " + o + " from url " + window.location)
        }.bind(this), false, null, false)
    }
    };

    var _getInfoAtPoint = WMSLayer.prototype.getInfoAtPoint;
    WMSLayer.prototype.getInfoAtPoint = function (e, t, i, n) {
        if(this._source.wmsSourceGetFeatureInfo.infoFormat === "application/vnd.ogc.gml"){
            if (this._source.width && this._source.height && this._source.extent) {
                this.getFields(e, t);
                var r = MapUtil.pointConvertMapToScreen(e, t, this._source.width, this._source.height, this._source.extent),
                    o = void 0 !== this._source.wmsSourceGetFeatureInfo.exceptions && null !== this._source.wmsSourceGetFeatureInfo.exceptions && "" !== this._source.wmsSourceGetFeatureInfo.exceptions ? "&exceptions=" + this._source.wmsSourceGetFeatureInfo.exceptions : "",
                    s = (this._source.wmsSourceGetFeatureInfo.src ? this._source.wmsSourceGetFeatureInfo.src : this._source.src) + "?&SERVICE=WMS&request=GetFeatureInfo&version=" + this._source.wmsSourceGetFeatureInfo.version + (this._source.wmsSourceGetMap.version >= "1.3.0" ? "&crs=" : "&srs=") + this._source.wmsSourceGetMap.crs + "&format=" + this._source.wmsSourceGetMap.format + "&transparent=" + this._source.wmsSourceGetMap.transparent + "&styles=" + (null === this._source.wmsSourceGetMap.bgcolor ? "" : "&bgcolor=" + this._source.wmsSourceGetMap.bgcolor) + "&layers=" + this._source.wmsSourceGetFeatureInfo.layers.join() + o + "&bbox=" + (this._source.wmsSourceGetMap.version >= "1.3.0" && "EPSG:4326" === this._source.wmsSourceGetMap.crs ? this._source.extent.minY + "," + this._source.extent.minX + "," + this._source.extent.maxY + "," + this._source.extent.maxX : this._source.extent.minX + "," + this._source.extent.minY + "," + this._source.extent.maxX + "," + this._source.extent.maxY) + "&WIDTH=" + this._source.width + "&HEIGHT=" + this._source.height + "&QUERY_LAYERS=" + this._source.wmsSourceGetFeatureInfo.layers.join() + "&INFO_FORMAT=" + this._source.wmsSourceGetFeatureInfo.infoFormat + "&FEATURE_COUNT=" + (this._source.wmsSourceGetFeatureInfo.featureCount > 0 ? this._source.wmsSourceGetFeatureInfo.featureCount : 1) + "&X=" + Math.round(r.x) + "&Y=" + Math.round(r.y) + (this._source.wmsSourceGetMap.version >= "1.3.0" ? "&I=" + Math.round(r.x) : "") + (this._source.wmsSourceGetMap.version >= "1.3.0" ? "&J=" + Math.round(r.y) : ""),
                    u = "text/xml" === this._source.wmsSourceGetFeatureInfo.infoFormat;
                    Util.loadXML(s, function (r, o) {
                        var a = "";
                        if (u) {
                            var s = r.getElementsByTagName("FIELDS");
                            if (s.length > 0) 
                                for (var d = s.length, h = 0; h < d; h++) {
                                    for (var p = s[h].getAttributeNames(), f = p.length, m = 0; m < f; m++) 
                                        a += "<b>" + p[m] + "</b>: " + s[h].getAttribute(p[m]) + "\n";
                                    a += "\n"
                                } else 
                                    a = l.default.escapeHtml(Util.xmlToString(r))
                            } else if(this.fields){
                                r = Util.parseXML(r);
                                _.forEach(this.fields, function(fields, layer){
                                    var s = r.getElementsByTagName(layer + "_layer");
                                    if (s.length > 0) {
                                        var layerName = s[0].getElementsByTagName("gml:name")[0].textContent;
                                        var f = s[0].getElementsByTagName(layer + "_feature");
                                        if (f.length > 0) {
                                            a += '<b style="font-size:110%">' + layerName + "</b>\n";
                                            for (var d = f.length, h = 0; h < d; h++) {
                                                _.map(fields, function(field){
                                                    var v = f[h].getElementsByTagName(field);
                                                    if (v.length > 0) {
                                                        a += "<b>" + field + "</b>: " + v[0].textContent + "\n";
                                                    }
                                                });
                                                a += "\n";
                                            }
                                        }
                                    }
                                });
                            } else 
                            a = r;
                        i.call(n || this, {
                            layer: this,
                            point: [ e, t ],
                            searchRadius: 1,
                            features: [],
                            text: a,
                            maxCount: Number.POSITIVE_INFINITY
                        })
                    }.bind(this), function (r, o) {
                        throw i.call(n || this, {
                            layer: this,
                            point: [ e, t ],
                            searchRadius: 1,
                            features: [],
                            maxCount: Number.POSITIVE_INFINITY
                        }),
                        new Error("CartoVista loading failed for resource " + o + " from url " + window.location)
                    }.bind(this), !0, null, !u)
            } else 
                console.warn("Can't get feature info on WMS layer " + this.name + " because size or extent not set.")
        } else _getInfoAtPoint.call(this, e, t, i, n); 
    };
